@if (toast.message()) {
<div class="toast-container">
  {{ toast.message() }}
</div>
}
